import React from 'react';
import classNames from 'classnames';
import Select from 'react-select';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import CancelIcon from '@material-ui/icons/Cancel';
import {blueGrey, grey} from '@material-ui/core/colors';


const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  input: {
    display: 'flex',
    padding: 0,
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden',
    padding:'0px 10px',
  },
  singleValue: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden',
  },
  noOptionsMessage: {
    fontSize: 14,
    color:grey[500],
    padding: '8px 8px',
  },
  placeholder: {
    position: 'absolute',
    fontSize: 14,
    paddingLeft:'2px',
    color:grey[400]
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
    fontSize: 14,
    maxHeight:'200px'
  }
});

function NoOptionsMessage(props) {
  return (
    <Typography
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function Option(props) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
        fontSize:14
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography
      noWrap
      variant='caption'
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function SingleValue(props) {
  return (
    <div className={props.selectProps.classes.singleValue}>
      <Typography noWrap variant='body2'>
        {props.children}
      </Typography>
    </div>
    
  );
}

function ValueContainer(props) {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

function MultiValue(props) {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      className={classNames(props.selectProps.classes.chip, {
        [props.selectProps.classes.chipFocused]: props.isFocused,
      })}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  );
}

//function Menu(props) {
//  return (
//    <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
//      {props.children}
//    </Paper>
//  );
//}

const components = {
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};

class InputSimpleSelect extends React.Component{
  state = {
    single: null,
    multi: null,
  }


  handleChange = (item) => {
    const {data, onChange} = this.props;
    let temp = {...data};
    temp.value = item.value;
    temp.isValid = true;
    temp.isVisited = true;
    onChange(temp);
  };

  render() {
    const { classes, data, wrap } = this.props;

    const selectStyles = {
      control: styles => ({
        ...styles,
        backgroundColor: "white",
        fontSize:'1em',
        fontFamily:'Montserrat',
        padding:'5px 2px',
        borderRadius:'40px',
        borderColor: blueGrey[100],
        '&:focus': {
          borderWidth:'1px',
          borderColor: blueGrey[500],
        },
        '&:hover': {
          borderWidth:'1px',
          borderColor: blueGrey[200],
        },
      }),
      menuList: styles => ({
        ...styles,
        maxHeight:'200px',
      })
    };

    let options;
    let value;
    let isClearable;
    let label = '';
    let placeholder = '';
    let isRequired = false

    if(data){
      options = data.options;
      isClearable = data.isClearable;
      isRequired = data.isRequired
      options.forEach((item, key) => {
        if(item.value === data.value){
          value = key;
        }
      })
      if(data.config.label){
        label = data.config.label
      }
      if(data.config.placeholder){
        placeholder = data.config.placeholder
      }
    }

    let gridLabel = 4;
    let gridContent = 8;
    let textPosition = 'right';
    let spacingItems = 16;

    if(wrap){
      if(wrap === 'vertical'){
        gridLabel = 12;
        gridContent = 12;
        textPosition = 'left';
        spacingItems = 0;
      }
    }

    return (
      <Grid container spacing={spacingItems} alignItems='center'>
        <Grid item xs={12} md={gridLabel}>
          <Typography variant='subtitle2' align={textPosition} style={{fontSize:'0.9em', fontWeight:'600', color: grey[700], padding:'8px 8px'}}>
          {label + (isRequired ? '*' : '')}
          </Typography>
        </Grid>
        <Grid item xs={12} md={gridContent}>
          <div style={{marginTop:'0px', marginBottom:'4px'}}>
            <Select
              classes={classes}
              styles={selectStyles}
              options={options}
              components={components}
              value={value !== undefined ? options[value] : null}
              onChange={this.handleChange}
              placeholder={placeholder}
              isClearable={isClearable}
            />
          </div>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles, { withTheme: true })(InputSimpleSelect);
